import styled, { css } from 'styled-components';
import { HEADER_VERSIONS } from 'src/components/ZillowNavbar/constants';
import { getBreakpointsForHeaderVersion } from 'src/components/ZillowNavbar/utils/getBreakpointsForHeaderVersion';

export const HomeLoansDashboardLinkContainer = styled.div<{
    version: HEADER_VERSIONS;
}>`
    ${({ version }) => css`
        @media (min-width: ${getBreakpointsForHeaderVersion(version).DESKTOP}px) {
            max-width: 300px;
        }
    `}
`;
